import React, { useState } from 'react';
import axios from 'axios';
import Results from './Results';
import './Dictionary.css';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Photos from './Photos';

export default function Dictionary() {
  let [keyword, setKeyword] = useState('');
  let [results, setResults] = useState(null);
  let [photos, setPhotos] = useState(null);

  function handleResponse(response) {
    console.log(response);
    setResults(response.data[0]);
  }
  function handlePhotosResponse(response) {
    setPhotos(response.data.photos);
  }
  function error() {
    alert(`No exact match found for "${keyword}"`);
  }

  function search(event) {
    event.preventDefault();

    let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
    axios.get(apiUrl).then(handleResponse).catch(error);

    let photosApiKey = '94a8844c364b98af003b9tao706b3068';
    let photosApiUrl = `https://api.shecodes.io/images/v1/search?query=${keyword}&key=${photosApiKey}`;
    axios.get(photosApiUrl).then(handlePhotosResponse);
  }

  function handleKeywordChange(event) {
    setKeyword(event.target.value);
  }

  return (
    <Container className="Dictionary mt-5">
      <section>
        <Row className="justify-content-md-center">
          <Col md="8">
            <Form onSubmit={search}>
              <InputGroup className="md-6">
                <Form.Control
                  type="search"
                  autoFocus={true}
                  onChange={handleKeywordChange}
                />
                <Button
                  className="button"
                  variant="outline-secondary"
                  type="submit"
                >
                  Submit
                </Button>
              </InputGroup>
              <Form.Text className="text-muted">
                for example: dog, sandwich, wine etc.
              </Form.Text>
            </Form>
          </Col>
        </Row>
      </section>
      <Results results={results} />
      <Photos photos={photos} />
    </Container>
  );
}
